# Массовая привязка к коллекциям и/или продуктам, индивидуальный набор на
# элемент (референсный UpdateContentManyMutation + AddToProductButton)
mutation UpdateContentMany($input: [UpdateContentManyInput!]!) {
  updateContentMany(input: $input) {
    id
    collectionIds
    productIds
  }
}
